module.exports = __webpack_public_path__ + "media/images/motherday-f5eff4212c705374568414eb3f6f5758.jpg";